import EventProcessor from "../../../core/internal/event/EventProcessor"
import UserEvent from "../../../core/internal/event/UserEvent"
import { SessionManager } from "../../../core/internal/session/SessionManager"
import { UserManager } from "../../../core/internal/user/UserManager"
import { SessionEventTracker } from "../../session/track/index.browser"
import { Lifecycle } from "../../../core/internal/lifecycle/Lifecycle"
import { LifecycleChangeListener } from "../../../core/internal/lifecycle/LifecycleChangeListener"
import { UserEventDedupDeterminer } from "../dedup/UserEventDedupDeterminer"
import { UserEventDecorator } from "../../../core/internal/user/UserEventDecorator"
import { OptOutListener } from "../../../core/internal/optout/OptOutListener"

export default class BrowserEventProcessor implements EventProcessor, LifecycleChangeListener, OptOutListener {
  private decorators: UserEventDecorator[] = []

  constructor(
    private readonly delegate: EventProcessor,
    private readonly eventDedupDeterminer: UserEventDedupDeterminer,
    private readonly sessionManager: SessionManager,
    private readonly userManager: UserManager
  ) {}

  addDecorator(decorator: UserEventDecorator): void {
    this.decorators.push(decorator)
  }

  process(event: UserEvent): void {
    if (!SessionEventTracker.isSessionEvent(event)) {
      const currentUser = this.userManager.currentUser
      this.sessionManager.startNewSessionIfNeeded({ oldUser: currentUser, newUser: currentUser, timestamp: event.timestamp })
    }

    if (this.eventDedupDeterminer.isDedupTarget(event)) {
      return
    }

    const decoratedEvent = this.decorators.reduce((acc, decorator) => decorator.decorate(acc), event)
    this.delegate.process(decoratedEvent)
  }

  flush(sync: boolean): void {
    this.delegate.flush(sync)
  }

  close(): void {
    this.delegate.close()
  }

  onOptOutChanged(optOut: boolean): void {
    // NOTE: opt-out false -> true 변경될 때 flush
    if (optOut) {
      this.delegate.flush(false)
    }
  }

  onLifecycleChanged(lifecycle: Lifecycle, _: number): void {
    switch (lifecycle) {
      case "hidden":
      case "pagehide":
        return this.flush(true)
      case "blur":
      case "focus":
      case "locationChange":
      case "visible":
      case "pageshow":
        return
    }
  }
}
